import React, { useState, useRef, useEffect, useCallback } from "react";
import { withTranslation } from "react-i18next";

import LockImg from "../../assets/images/pinimg/lock_icon.png";
import BlockImg from "../../assets/images/pinimg/block.png";
import ShuffleImg from "../../assets/images/pinimg/random-number.png";
import KeyboardImg from "../../assets/images/pinimg/view.png";
import { TOKEN_KEY } from "../../helpers/url_helper";
import { makeAjax, respStatus, showMessage, url, handleLogout } from "../../helpers/global_helper";
import { shuffleArray, handleNumberInput, pinStatusCheck, NUMBERS, MAX_PIN_LENGTH } from "../../helpers/pinHelpers";
import { useNavigate } from "react-router-dom";
import ErrorInformationpopup from "./ErrorInformationpopup";

const LoginPin = ({ t }) => {
  const navigate = useNavigate();
  const [isKeypadOpen, setIsKeypadOpen] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [inputPin, setInputPin] = useState("");
  const keypadRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");

  useEffect(() => {
    setNumbers(shuffleArray(NUMBERS));
    pinStatusCheck(navigate);
  }, []);

  useEffect(() => {
    if (inputPin.length === MAX_PIN_LENGTH) {
      handleSubmit();
      handleClear();
    }
  }, [inputPin, handleSubmit]);

  useEffect(() => {
    if (!isKeypadOpen) return;
    const handleOutsideClick = (event) => {
      if (keypadRef.current && !keypadRef.current.contains(event.target)) {
        setIsKeypadOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isKeypadOpen]);

  const openKeypad = () => setIsKeypadOpen(true);
  const closeKeypad = () => setIsKeypadOpen(false);

  /** Handle PIN input (max 6 digits) */
  const handleNumberClick = (num) => {
    setInputPin((prev) => handleNumberInput(prev, num, MAX_PIN_LENGTH));
  };

  const handleClear = () => setInputPin("");
  const handleDelete = () => {
  setInputPin((prev) => prev.slice(0, -1));
};

  const handleSubmit = useCallback(async () => {
    if (inputPin.length !== MAX_PIN_LENGTH) {
      return;
    }

    try {
      const payload = { pin: inputPin };

      const response = await makeAjax(url.PLAYER_API.verifyPin, payload, url.PLAYER_MS_EXT);
      if (response?.status !== respStatus.SUCCESS) {
        showMessage(response);
        return;
      }

      const { isVerified, blocked } = response?.data || {};

      if (isVerified === true) {
        localStorage.setItem("__ps", null);
        navigate('/');
        return;
      }

      if (blocked === true) {
       navigate('/pin-accessdenied');
        return;
      }

      showMessage(t(response.data.message));
      setInputPin("");
      closeKeypad();

    } catch (error) {
      console.error('PIN verification failed', error);
    }
  }, [inputPin, navigate, t]);


  return (
    <>
      <div className="pin-container">
        <div className="login-pin">
          <div className="pin-heading">
            <div className="welcome">
              <p>{t("welcome")}</p>
              <p className="username">{localStorage.getItem("nickname")}</p>
            </div>
            <div className="header-title">
              {t("security_validation")}
            </div>
          </div>
          <div className="inner-content">
            <div className="middle-icon d-flex">
              <InfoItem img={LockImg} text={t("enter_pin_prompt")} />
              <div className="right-line" />
              <InfoItem img={BlockImg} text={t("pin_blocked")} />
              <div className="right-line" />
              <InfoItem img={ShuffleImg} text={t("random_buttons_notice")} />
            </div>

            <div className="keypad login-keypad">
              <div className="top-bar">
                <div className="search-box" onClick={openKeypad}>
                  <input
                    type="password"
                    placeholder={t("enter_pin")}
                    value={inputPin}
                    readOnly
                  />
                  <span className="grid-icon">
                    <img src={KeyboardImg} alt="Open keypad" />
                  </span>
                </div>

                <button className="logout-btn" type="button" onClick={() => handleLogout(TOKEN_KEY)}>
                  {t("logout")}
                </button>
              </div>

              {isKeypadOpen && (
                <div className="keypad-wrapper" ref={keypadRef}>
                  <div className="keypad-body">
                    <div className="numbers">
                      {numbers.slice(0, 9).map((num) => (
                        <button
                          key={num}
                          type="button"
                          onClick={() => handleNumberClick(num)}
                          disabled={inputPin.length >= MAX_PIN_LENGTH}
                        >
                          {num}
                        </button>
                      ))}
                      <button
                        className="last"
                        type="button"
                        onClick={() => handleNumberClick(numbers[9])}
                        disabled={inputPin.length >= MAX_PIN_LENGTH}
                      >
                        {numbers[9]}
                      </button>
                    </div>

                    <div className="actions">
                      <button
                        className="process"
                        type="button"
                        onClick={() => {
                          handleSubmit();
                          handleClear();
                          // closeKeypad();
                        }}
                        // disabled={inputPin.length !== MAX_PIN_LENGTH}
                      >
                        {t("clear_pin")}
                      </button>

                      <button
                        className="delete"
                        type="button"
                        onClick={handleDelete}
                      >
                        {t("delete")}
                      </button>

                      <button
                        className="tutup"
                        type="button"
                        onClick={closeKeypad}
                      >
                        {t("close")}
                      </button>
                    </div>
                  </div>
                </div>
              )}

            </div>

          </div>
          <div className="footer-note" style={{ color: "#EAFF00" }}>
            *{t("forgot_pin")}
          </div>
        </div>

      </div>
      {showPopup && <div className="main-overlay" />}

      {showPopup && (
        <ErrorInformationpopup t={t}
          message={popupMsg}
          onClose={() => setShowPopup(false)}
        />
      )}

    </>
  );
};

const InfoItem = ({ img, text }) => (
  <div>
    <div className="icon">
      <img src={img} alt="" />
    </div>
    <div className="desc">{text}</div>
  </div>
);

export default withTranslation()(LoginPin);
